import { profileModule } from "./profile/profile-module";

export const modules = {
  profile: profileModule,
};

// Modules to persist cross sessions
export const toPersist = ["profile"];
